import React, {Component} from 'react';
import {withStyles} from '@material-ui/core';
import config from "../config";
import {Helmet} from "react-helmet";
import {metaDescriptions, metaImages, metaTitles, title} from "../website-utils/meta";
import {Link} from "react-router-dom";
import {connect} from "react-redux";
import {fetchBusinessById} from "../state/actions/business";
import ScrollToTopOnMount from "../website-utils/ScrollToTopOnMount";

import BusinessHeader from '../parts/BusinessHeader';
import BusinessEndCallToAction from '../parts/BusinessEndCallToAction';
import Footer from '../parts/Footer';


export class PricingPage extends React.Component {
  componentDidMount() {
    window.analytics.page("Business", "FAQ");

    // Check if the user is "logged in"
    const businessId = localStorage.getItem('businessId');
    if (businessId) {
      this.props.fetchBusinessById(businessId);
    }
  }

  getStartedClicked = () => {
    if (this.props.business) {
      this.props.history.push('/' + this.props.business.slug);
    } else {
      this.props.history.push(config.routes.businessSignUp);
    }
  };

  render() {
    window.prerenderReady = true;

    const {classes} = this.props;

    return (
      <div className="business home">
        <Helmet>
          {title('SingleShift - Business FAQ')}
          {metaTitles('SingleShift - Business FAQ')}
          {metaDescriptions('Book online in seconds and schedule a Pro for whenever you need them in the next day or week.')}
        </Helmet>
        <ScrollToTopOnMount/>

        {/* HERO */}
        <div className={`${classes.hero} hero`}>
          <div className="container">
            <BusinessHeader/>
            <div className="row justify-content-md-center">
              <div className={`${classes.headline} col-md-6 headline text-center`}>
                <p className={`${classes.pageIdentifier} text-uppercase`}>Frequently Asked Questions</p>
                <h1>Questions? Meet Answers.</h1>
                <p>Have a question that isn't covered? <Link className={classes.heroLink} to={config.routes.contact}>Talk to someone</Link></p>
              </div>
            </div>
          </div>
        </div>

        {/* QUESTIONS */}
        <div className={classes.section}>
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <h4 className={classes.question}>How do I pay the Pro after the shift?</h4>
                <div className={classes.answer}>
                  <p>We charge the full amount, wages and fee, to your credit card then pay the Pro on your behalf.</p>
                </div>
              </div>
              <div className="col-md-6">
                <h4 className={classes.question}>How much does SingleShift cost?</h4>
                <div className={classes.answer}>
                  <p>SingleShift charges $10 per shift filled. You can find a more detailed information on our <a href={config.routes.businessPricing}>Pricing Page</a>.</p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <h4 className={classes.question}>What happens after I post a shift?</h4>
                <div className={classes.answer}>
                  <p>SingleShift sends your posting to our Pros via SMS. If they are interested, they are connected with you via WhatsApp.</p>
                </div>
              </div>
              <div className="col-md-6">
                <h4 className={classes.question}>What type of people are on your platform?</h4>
                <div className={classes.answer}>
                  <p>All types but mainly a mix of students or new graduates who have worked in food and beverage in the past (typically servers and baristas) or food and beverage professionals who work full-time at restaurants looking to make extra money (typically cooks).</p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <h4 className={classes.question}>How do I know if the Pro is going to be good?</h4>
                <div className={classes.answer}>
                  <p>Everyone must apply online with their work experience before they're allowed to accept jobs on SingleShift. We manually review applications and don't accept anyone without prior food and beverage experience.</p>
                </div>
              </div>
              <div className="col-md-6">
                <h4 className={classes.question}>Will I be able to screen Pros before they work?</h4>
                <div className={classes.answer}>
                  <p>We believe all our Pros are more than up to the task but if you'd like speak to them before hand, you can setup a quick phone call with them after you're introduced to them via WhatsApp.</p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <h4 className={classes.question}>What happens if they don’t show up?</h4>
                <div className={classes.answer}>
                  <p>We built SingleShift to be as reliable as possible and as a result, no shows are very rare but they do happen. When it does happen, someone from SingleShift will re-post your shift at an increased wage (paid for by SingleShift) and when we find someone, we will send a Grab to pick them up and send them to you.</p>
                </div>
              </div>
              <div className="col-md-6">
                <h4 className={classes.question}>Is SingleShift based in Singapore?</h4>
                <div className={classes.answer}>
                  <p>Yes!</p>
                </div>
              </div>
            </div>
          </div>
        </div>

      <BusinessEndCallToAction/>

      <Footer/>

      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  business: state.business.item,
});

const mapDispatchToProps = (dispatch) => ({
  fetchBusinessById: (id) => dispatch(fetchBusinessById(id)),
});

const styles = (theme) => ({
  hero: {
    backgroundColor: '#004DAA',
  },
  heroLink: {
    color: '#ffffff',
    textDecoration: 'underline',
  },
  headline: {
    margin: '60px 0',
    paddingBottom: '0 !important',
  },
  heroBtn: {
    marginBottom: '15px',
  },
  pageIdentifier: {
    marginBottom: '10px !important',
    fontSize: '18px !important',
    letterSpacing: '0.75px',
    fontWeight: '800',
  },
  section: {
    padding: '100px 0',
    borderBottom: '1px solid #efefef',
  },
  question: {
    fontSize: '18px',
    lineHeight: '1.666667',
    fontWeight: '800',
    marginBottom: '15px',
  },
  answer: {
    marginBottom: '60px',
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(PricingPage));



// WEBPACK FOOTER //
// ./src/pages/BusinessFaqPage.js